import { GENERIC_WINDOW_NAME } from '../config/url-consts';

/**
 * This function is used to open a PDF document using a URL for the PDF URL.
 * @param {string} url URL to PDF
 * @param {string} winName Window name to allow for multiple windows
 * @param {number} width width of window
 * @param {number} height height of window
 */
const openPdfWin = (
  url: string,
  winName: string,
  width: number,
  height: number
): void => {
  // Setup the window dimensions
  let winWidth = 0;

  if (typeof width === 'number') {
    winWidth = width < 1 ? Math.floor(window.screen.availWidth * width) : width;
  } else {
    winWidth = Math.floor(window.screen.availWidth * 0.65);
  }

  let winHeight = 0;

  if (typeof width === 'number') {
    winHeight =
      height < 1 ? Math.floor(window.screen.availHeight * height) : height;
  } else {
    winHeight = Math.floor(window.screen.availHeight * 0.85);
  }

  // Setup window name (Use current time to make unique)
  const windowName =
    typeof winName !== 'string' || winName === ''
      ? GENERIC_WINDOW_NAME + new Date().getTime()
      : winName;

  const left = Math.floor(
    window.screen.availWidth * ((Math.random() + 1) / 45)
  );

  const top = Math.floor(
    window.screen.availHeight * ((Math.random() + 1) / 45)
  );

  const parms = 'resizable=yes,scrollbars=yes';

  // Do we want to keep this pattern? Or should we return it and allow users to choose what to do with it?
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.PDFWINDOW = window.open(
    url,
    windowName,
    `${parms},width=${winWidth},height=${winHeight},top=${top},left=${left}`
  );

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.PDFWINDOW.focus();
};

export default openPdfWin;
